import PubSub from "underpub-js";

var AvailabilityMap = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-AvailabilityMap',
	};

	$.extend(true, this.options, options);

	// Gallery properties
	this.$imageWrapper = null;
	this.$dummyImage = null;
	this.$floorImages = [];
	this.currentFloorIndex = null;
	
	// Filter properties
	this.selectedResidenceType = null; // Will store Unit Category ID
	this.$allPopups = null;

};

AvailabilityMap.prototype.init = function() {

	var self = this;

	// Initialize the background image gallery
	this.initGallery();

	// Initialize popup references for filtering
	this.initPopups();

	// Set the initial floor (default to first floor)
	this.setInitialFloor();

	// Set up floor selector - check for standard select elements first, then Webflow dropdowns
	var $floorSelect = this.options.$el.find('.availability-map_floor-select');
	
	if ($floorSelect.length) {
		// Use standard select element
		this.setupStandardSelects();
		
		// Set the select value to match the initial floor (Floor 1 = value "1")
		// Set it directly without triggering change since we've already initialized the floor
		setTimeout(function() {
			$floorSelect.val('1');
		}, 10);
	} else {
		// Use Webflow dropdowns
		this.setupFloorDropdown();
	}
	
	// Set up reset filters button
	this.setupResetButton();
	
	// Subscribe to requests for current floor (for late-initializing popups)
	PubSub.subscribe('availabilityMap:requestCurrentFloor', function() {
		if (self.currentFloorIndex !== null) {
			PubSub.publish('availabilityMap:currentFloor', {
				floorIndex: self.currentFloorIndex + 1 // Convert to 1-based
			});
		}
	});

};

/**
 * Initialize the background image gallery
 * Finds the image wrapper and sets up references to all images
 */
AvailabilityMap.prototype.initGallery = function() {

	var self = this;

	// Find the image wrapper element
	this.$imageWrapper = this.options.$el.find('.availability-map_image-wrapper');

	if (!this.$imageWrapper.length) {
		console.warn('AvailabilityMap: Image wrapper not found');
		return;
	}

	// Ensure the wrapper is positioned relatively so absolutely positioned images and overlay are contained
	this.$imageWrapper.css({
		position: 'relative'
	});

	// Get all images inside the wrapper
	var $allImages = this.$imageWrapper.find('.availability-map_image');

	if (!$allImages.length) {
		console.warn('AvailabilityMap: No images found in image wrapper');
		return;
	}

	// Find the dummy image (first image with class 'dummy')
	this.$dummyImage = $allImages.filter('.dummy').first();

	if (!this.$dummyImage.length) {
		console.warn('AvailabilityMap: Dummy image not found');
		return;
	}

	// Get all floor images (all images except the dummy)
	// All floor images (including floor 1) are absolutely positioned
	this.$floorImages = $allImages.not('.dummy');

	// Ensure dummy image is always hidden (it's only for spacing)
	if (this.$dummyImage.length) {
		this.$dummyImage.css({
			opacity: 0,
			zIndex: -10,
			pointerEvents: 'none'
		});
	}

	// Ensure all floor images are initially hidden
	// Floor 1 is at index 0, Floor 2 is at index 1, etc.
	this.$floorImages.each(function() {
		var $img = $(this);
		$img.css({
			opacity: 0,
			pointerEvents: 'none'
		}).removeClass('active');
	});

};

/**
 * Initialize popup references for filtering
 * Finds all popup units and stores references for filtering
 */
AvailabilityMap.prototype.initPopups = function() {
	// Find all popup units within this map instance
	this.$allPopups = this.options.$el.find('[data-amp-component="PopupUnit"]');
	
	if (!this.$allPopups.length) {
		console.warn('AvailabilityMap: No popups found for filtering');
		return;
	}
};

/**
 * Apply filters to all popups
 * Hides/shows popups based on selected Residence Type filter
 */
AvailabilityMap.prototype.applyFilters = function() {
	if (!this.$allPopups || !this.$allPopups.length) {
		return;
	}
	
	var self = this;
	var visibleCount = 0;
	var hiddenCount = 0;
	
		this.$allPopups.each(function() {
		var $popup = $(this);
		var shouldShow = true;
		
		// Check Residence Type filter (Unit Category)
		if (self.selectedResidenceType) {
			var popupCategoryIds = $popup.attr('data-unit-category-ids');
			
			// If popup has no category IDs, hide it
			if (!popupCategoryIds || popupCategoryIds === '') {
				shouldShow = false;
			} else {
				// Split comma-separated category IDs and check if selected category is in the list
				var categoryIdsArray = popupCategoryIds.split(',').map(function(id) {
					return id.trim();
				});
				
				// Check if selected category ID is in the popup's category IDs
				if (categoryIdsArray.indexOf(self.selectedResidenceType) === -1) {
					shouldShow = false;
				}
			}
		}
		
		// Show or hide the popup
		if (shouldShow) {
			$popup.css({
				display: 'block',
				opacity: 1,
				pointerEvents: 'auto'
			});
			visibleCount++;
		} else {
			$popup.css({
				display: 'none',
				opacity: 0,
				pointerEvents: 'none'
			});
			hiddenCount++;
		}
	});
};

/**
 * Set the initial floor (defaults to first floor, index 0)
 * @param {number} floorIndex - Optional floor index (0-based). Defaults to 0.
 */
AvailabilityMap.prototype.setInitialFloor = function(floorIndex) {

	var self = this;

	// Default to first floor if no index provided
	var index = floorIndex !== undefined ? floorIndex : 0;

	// Validate index
	// Floor index 0 = Floor 1, Floor index 1 = Floor 2, etc.
	// All floors are in the $floorImages array
	if (index < 0 || index >= this.$floorImages.length) {
		console.warn('AvailabilityMap: Invalid floor index:', index, 'Available floors:', this.$floorImages.length);
		return;
	}

	// Set the initial floor
	this.changeFloor(index);
	
	// Publish initial floor set event (convert to 1-based for popups)
	// Delay slightly to ensure popups have time to subscribe
	var self = this;
	var publishedFloorIndex = index + 1; // Convert to 1-based
	setTimeout(function() {
		PubSub.publish('availabilityMap:initialFloorSet', {
			floorIndex: publishedFloorIndex
		});
	}, 50);

};

/**
 * Change the floor and update the background image
 * @param {number} floorIndex - The floor index (0-based, where 0 = first floor/dummy image)
 */
AvailabilityMap.prototype.changeFloor = function(floorIndex) {

	var self = this;

	console.log('AvailabilityMap.changeFloor called', {
		floorIndex: floorIndex,
		currentFloorIndex: this.currentFloorIndex,
		floorImagesCount: this.$floorImages ? this.$floorImages.length : 0,
		hasDummyImage: this.$dummyImage && this.$dummyImage.length > 0
	});

	// Floor index 0 means show floor 1 (first image in $floorImages array)
	// Floor index 1 means show floor 2 (second image in $floorImages array), etc.
	// The dummy image is never shown - it's only for spacing
	
	// Hide current floor image if one is active
	if (this.currentFloorIndex !== null) {
		var $currentImage = this.$floorImages.eq(this.currentFloorIndex);
		if ($currentImage.length) {
			console.log('AvailabilityMap: Hiding floor image', this.currentFloorIndex + 1);
			$currentImage.css({
				opacity: 0,
				pointerEvents: 'none'
			}).removeClass('active');
		}
	}

	// Show new floor image
	// Floor index 0 = Floor 1 (first image in array)
	// Floor index 1 = Floor 2 (second image in array), etc.
	if (floorIndex < 0 || floorIndex >= this.$floorImages.length) {
		console.warn('AvailabilityMap: Invalid floor index:', floorIndex, 'Available floors:', this.$floorImages.length);
		return;
	}
	
	var $newImage = this.$floorImages.eq(floorIndex);
	console.log('AvailabilityMap: Showing floor image', floorIndex + 1, 'array index:', floorIndex, $newImage.length);
	
	if ($newImage.length) {
		$newImage.css({
			opacity: 1,
			pointerEvents: 'auto'
		}).addClass('active');
	} else {
		console.warn('AvailabilityMap: Floor image not found at index:', floorIndex);
		return;
	}

	// Update current floor index
	this.currentFloorIndex = floorIndex;
	
	// Publish floor change event (convert to 1-based for popups)
	var publishedFloorIndex = floorIndex + 1; // Convert to 1-based
	PubSub.publish('availabilityMap:floorChanged', {
		floorIndex: publishedFloorIndex
	});

};

/**
 * Set up standard select elements for filters
 */
AvailabilityMap.prototype.setupStandardSelects = function() {
	var self = this;
	
	// Floor selector - find the actual select element (Webflow may wrap it)
	// Try multiple selectors to find the element
	var $floorSelect = this.options.$el.find('select.availability-map_floor-select');
	
	// If not found, try class selector (in case it's not a direct select)
	if (!$floorSelect.length) {
		$floorSelect = this.options.$el.find('.availability-map_floor-select');
	}
	
	// If still not found, try finding within form
	if (!$floorSelect.length) {
		var $form = this.options.$el.find('form');
		if ($form.length) {
			$floorSelect = $form.find('select.availability-map_floor-select');
		}
	}
	
	if ($floorSelect.length) {
		var selectElement = $floorSelect[0];
		
		console.log('AvailabilityMap: Setting up floor select handler', {
			selectElement: selectElement,
			floorImagesCount: self.$floorImages ? self.$floorImages.length : 0
		});
		
		// Function to handle floor change
		var handleFloorChange = function(selectedValue) {
			console.log('AvailabilityMap: Floor select changed to:', selectedValue);
			var selectedFloorIndex = parseInt(selectedValue, 10);
			
			// Validate that we have floor images available
			if (!self.$floorImages || self.$floorImages.length === 0) {
				console.warn('AvailabilityMap: No floor images available');
				return;
			}
			
			if (!isNaN(selectedFloorIndex) && selectedFloorIndex > 0) {
				// Convert from 1-based (from select) to 0-based (for JavaScript)
				// Floor 1 = index 0, Floor 2 = index 1, etc.
				var floorIndex = selectedFloorIndex - 1;
				
				console.log('AvailabilityMap: Converting floor index', {
					selectedFloorIndex: selectedFloorIndex,
					floorIndex: floorIndex,
					availableFloors: self.$floorImages.length
				});
				
				// Validate floor index is within bounds
				if (floorIndex >= 0 && floorIndex < self.$floorImages.length) {
					console.log('AvailabilityMap: Calling changeFloor with index:', floorIndex);
					self.changeFloor(floorIndex);
				} else {
					console.warn('AvailabilityMap: Invalid floor index:', floorIndex, 'Available floors:', self.$floorImages.length);
				}
			} else if (selectedValue === '' || selectedValue === null) {
				// Reset to first floor if empty selection
				if (self.$floorImages.length > 0) {
					console.log('AvailabilityMap: Resetting to first floor');
					self.changeFloor(0);
				}
			}
		};
		
		// Set up change event handler using jQuery
		$floorSelect.on('change', function() {
			console.log('AvailabilityMap: jQuery change event fired');
			handleFloorChange($(this).val());
		});
		
		// Also add native event listener as backup (in case Webflow interferes)
		if (selectElement) {
			selectElement.addEventListener('change', function() {
				console.log('AvailabilityMap: Native change event fired');
				handleFloorChange(this.value);
			}, true); // Use capture phase to catch before Webflow
		}
	} else {
		console.warn('AvailabilityMap: Floor select not found');
	}
	
	// Residence Type selector
	var $residenceTypeSelect = this.options.$el.find('.availability-map_bedrooms-select');
	if ($residenceTypeSelect.length) {
		$residenceTypeSelect.on('change', function() {
			var selectedValue = $(this).val();
			self.selectedResidenceType = selectedValue || null;
			self.applyFilters();
		});
	}
};

/**
 * Set up floor dropdown event listeners
 * Handles clicks on Webflow dropdown links for floor selection
 */
AvailabilityMap.prototype.setupFloorDropdown = function() {
	var self = this;
	
	// Find the first dropdown (Floor Level dropdown)
	var $floorDropdown = this.options.$el.find('.dropdown2_component').first();
	
	if (!$floorDropdown.length) {
		console.warn('AvailabilityMap: Floor dropdown not found');
		return;
	}
	
	// Set up click handlers on dropdown links
	$floorDropdown.find('.dropdown2_dropdown-link').on('click', function(e) {
		e.preventDefault();
		
		var $link = $(this);
		var linkText = $link.text().trim();
		
		// Extract floor number from text like "Floor 1", "Floor 2", etc.
		var floorMatch = linkText.match(/floor\s*(\d+)/i);
		if (floorMatch) {
			var selectedFloorIndex = parseInt(floorMatch[1], 10);
			
			// Update dropdown toggle text
			$floorDropdown.find('.dropdown2_toggle .text-size-small').text(linkText);
			
			// Convert from 1-based (from dropdown) to 0-based (for JavaScript)
			self.changeFloor(selectedFloorIndex - 1);
			
			// Close the dropdown (Webflow handles this, but we can ensure it closes)
			$floorDropdown.removeClass('w--open');
		}
	});
};

/**
 * Set up reset filters button
 * Resets all filters and shows all popups
 */
AvailabilityMap.prototype.setupResetButton = function() {
	var self = this;
	
	// Find reset button in the availability filter section
	var $resetButton = this.options.$el.find('.availability-filter_button a');
	
	if ($resetButton.length) {
		$resetButton.on('click', function(e) {
			e.preventDefault();
			
			// Reset filter state
			self.selectedResidenceType = null;
			
			// Reset dropdowns
			var $residenceTypeSelect = self.options.$el.find('.availability-map_bedrooms-select');
			
			if ($residenceTypeSelect.length) {
				$residenceTypeSelect.val('').trigger('change');
			}
			
			// Show all popups
			self.applyFilters();
		});
	}
};

export default AvailabilityMap;
